"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
var _tracing = require("@sentry/tracing");
var _config = _interopRequireDefault(require("./config"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ErrorsWhitelist = (0, _toConsumableArray2["default"])(_constants.SentryErrorsWhitelist);
var getSentryCredentials = function getSentryCredentials(enableUserFeedback, userFeedbackDialogProps) {
  return {
    dsn: _config["default"].sentryDns,
    release: _config["default"].appVersion,
    beforeSend: function beforeSend(event, hint) {
      if (ErrorsWhitelist.some(function (message) {
        var _event$exception, _hint$originalExcepti;
        return ((_event$exception = event.exception) === null || _event$exception === void 0 || (_event$exception = _event$exception.values[0]) === null || _event$exception === void 0 || (_event$exception = _event$exception.value) === null || _event$exception === void 0 ? void 0 : _event$exception.includes(message)) || ((_hint$originalExcepti = hint.originalException) === null || _hint$originalExcepti === void 0 || (_hint$originalExcepti = _hint$originalExcepti.message) === null || _hint$originalExcepti === void 0 ? void 0 : _hint$originalExcepti.includes(message));
      })) return null;
      if (enableUserFeedback && event.exception) {
        var dialogProps = {
          eventId: event.event_id,
          title: 'It looks like something went wrong.'
        };
        if (userFeedbackDialogProps) dialogProps = _objectSpread(_objectSpread({}, dialogProps), userFeedbackDialogProps);
        Sentry.showReportDialog(dialogProps);
      }
      return event;
    },
    integrations: [new _tracing.Integrations.BrowserTracing(), new Sentry.Integrations.Breadcrumbs({
      beacon: true,
      console: false,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      axios: true
    }), new Sentry.Replay()],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.2
  };
};
var sentry = {
  initialize: function initialize() {
    var additionalMessagesToBeIgnored = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var enableUserFeedback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var userFeedbackDialogProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (additionalMessagesToBeIgnored && additionalMessagesToBeIgnored.length > 0) ErrorsWhitelist.push.apply(ErrorsWhitelist, (0, _toConsumableArray2["default"])(additionalMessagesToBeIgnored));
    Sentry.init(getSentryCredentials(enableUserFeedback, userFeedbackDialogProps));
  },
  captureException: function captureException(error) {
    Sentry.captureException(error);
  },
  withScope: function withScope(error, errorInfo) {
    Sentry.withScope(function (scope) {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  },
  showReportDialog: function showReportDialog(eventId) {
    Sentry.showReportDialog({
      eventId: eventId
    });
  },
  Sentry: Sentry
};
var _default = exports["default"] = sentry;